<template>
    <div v-for="index in 6" :key="index">
        <div class="rounded-sm py-2">
            <div class="my-[1px] h-24 w-full animate-pulse rounded bg-slate-200" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'SkeletonUserLists',
}
</script>
